import React from "react"

// styling and images
import "./LoadingScreen.scss"
import GiftIcon from "../../images/js/Gift"

function LoadingScreen({mode}) {
  let text
  switch(mode) {
    case "paying":
      text = "die Zahlung wird verarbeitet ...";
      break
    case "initializePayment":
      text = "die Zahlung wird vorbereitet ...";
      break;
    case "finalizePayment":
      text = "die Zahlung wird abgeschlossen ...";
    default:
      text = "lade das perfekte Geschenk :)";
      break
  }
  return (
    <div id="s-loadingscreen">
      <div className="image-container">
        <div className="image">
          <GiftIcon fill="#333333" />
        </div>
      </div>
      <div className="text">
        {text}
      </div>
    </div>
  )
}

export default LoadingScreen